const initialState = {
    packages: [],
};

const marketplaceReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_MARKETPLACE_PACKAGES":
            return {
                ...state,
                packages: action.payload,
            };
        default:
            return state;
    }
};

export default marketplaceReducer;
